import kamala from '../../kamala'
import DateTimePicker from './Picker'

DateTimePicker.install = function (Vue) {
  kamala(Vue)
  Vue.component(DateTimePicker.name, DateTimePicker)
}

export default DateTimePicker
